import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest, map, Observable } from 'rxjs';
import { getAccount, getAccountPreferences } from '@capital-access/common/user';
import { getIdeasPortalAccessKey } from '../ideas-portal-access';

export interface PendoAccessResult {
  shouldHidePendo: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class PendoAccessService {
  constructor(private store: Store) {}

  checkAccess(): Observable<PendoAccessResult> {
    return combineLatest({
      account: this.store.select(getAccount),
      accountPreferences: this.store.select(getAccountPreferences)
    }).pipe(
      map(({ account, accountPreferences }) => {
        const ideasPortalPreference = accountPreferences?.find(p => p.key === getIdeasPortalAccessKey());
        const isIdeasPortalEnabled = ideasPortalPreference ? ideasPortalPreference.value === 'true' : true;
        const isRestrictedAccountSubType =
          account?.accountSubType === 'ConsultantsClient' || account?.accountSubType === 'PartnersClient';

        return {
          shouldHidePendo: !isIdeasPortalEnabled || isRestrictedAccountSubType
        };
      })
    );
  }
}
